module.exports = __webpack_public_path__ + "img/album09_05.b774a35d.jpg";